<template>
    <v-flex xs12 mb-4 pt-4 id="contacts">
        <v-layout>
            <v-flex xs8>
                <v-toolbar text>
                    <v-toolbar-title>Контакты</v-toolbar-title>
                </v-toolbar>
                <v-layout flex wrap>
                    <v-flex xs11>
                        <v-subheader class="pa-0">Адрес</v-subheader>
                        <v-text-field
                            ref="contacts_address"
                            v-model="contacts.address"
                            v-validate="'required'"
                            data-vv-name="address"
                            :error-messages="errors.collect('address')"
                            solo
                            text
                            required
                            single-line/>
                    </v-flex>
                    <v-flex xs11>
                        <v-layout>
                            <v-flex xs5>
                                <v-subheader class="pa-0">Телефон (основной)</v-subheader>
                                <v-text-field
                                    ref="contacts_phone_main"
                                    v-model="contacts.phone_main"
                                    v-validate="'required'"
                                    data-vv-name="phone"
                                    :error-messages="errors.collect('phone')"
                                    solo
                                    text
                                    single-line
                                    required/>
                            </v-flex>
                            <v-spacer/>
                            <v-flex xs5>
                                <v-subheader class="pa-0">Телефон (опционально)</v-subheader>
                                <v-text-field
                                    ref="contacts_phone_extra"
                                    v-model="contacts.phone_extra"
                                    solo
                                    text
                                    single-line/>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs11>
                        <v-subheader class="pa-0">E-mail</v-subheader>
                        <v-text-field
                            ref="contacts_email"
                            v-model="contacts.email"
                            v-validate="'required'"
                            data-vv-name="email"
                            :error-messages="errors.collect('email')"
                            solo
                            text
                            single-line
                            required/>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs4>
                <v-toolbar text>
                    <v-toolbar-title>Координаты</v-toolbar-title>
                </v-toolbar>
                <v-layout flex wrap>
                    <v-flex xs12>
                        <v-subheader class="pa-0">Долгота</v-subheader>
                        <v-text-field
                            ref="contacts_longitude"
                            v-model="contacts.longitude"
                            v-validate="'required'"
                            data-vv-name="longitude"
                            :error-messages="errors.collect('longitude')"
                            solo
                            text
                            single-line
                            required/>
                    </v-flex>
                    <v-flex xs12>
                        <v-subheader class="pa-0">Широта</v-subheader>
                        <v-text-field
                            ref="latitude"
                            v-model="contacts.latitude"
                            v-validate="'required'"
                            data-vv-name="latitude"
                            :error-messages="errors.collect('latitude')"
                            solo
                            text
                            single-line
                            required/>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    import {Validator} from 'vee-validate'
    export default {
        name: 'contactsSite',
        props: {
            contacts: {
                default: {}
            },
            validator: Validator
        },
        data: () => ({
            dictionary: {
                custom: {
                    address: {
                        required: 'Поле адрес не заполнено'
                    },
                    phone: {
                        required: 'Основной телефон не заполнен'
                    },
                    email: {
                        required: 'Почта не заполнена'
                    },
                    longitude: {
                        required: 'Долгота не указана'
                    },
                    latitude: {
                        required: 'Широта не указана'
                    }
                }
            }
        }),
        created () {
            if (this.validator) this.$validator = this.validator
        },
        mounted () {
            this.$validator.localize('ru', this.dictionary)
            this.$on('veeValidate', () => {
                this.$validator.validateAll()
            })
        }
    }
</script>
